import React from 'react';

export default function CurriculumSources({ sources = [], notice = '' }) {
    if (!sources.length && !notice) return null;
    return <div className="curriculum-sources">
        <p><strong>{sources.length ? 'CAPS sources used for generation' : 'Generated without a CAPS source'}</strong></p>
        {notice && <p role="status">{notice}</p>}
        {sources.map((source) => <p key={source.sha256 || source.url}>
            <a href={source.url} target="_blank" rel="noopener noreferrer">{source.title}</a> ({source.language})
            {source.retrievalMode === 'indexed-excerpts' && source.pages?.length > 0 && <small> — PDF pages {source.pages.join(', ')}</small>}
            {source.retrievalMode === 'full-pdf' && <small> — Full document used; generation may take longer.</small>}
        </p>)}
        <small>Review against your current ATP and any applicable CAPS amendments before use.</small>
    </div>;
}
